import React from 'react';
import { getSecondary } from '../../styles/colors';
import { BasicButton, TextInput } from '../../UI';
import { COLORS } from '../../utils/constants';
import { useColors } from '../../utils/hooks';
import FormRootLayout from './FormRootLayout';

const ConfigColors = ({ portal, updateAndSave, translate }) => {
	const {
		colors,
		setColors,
		recalculateWithPrimary
	} = useColors((portal && portal.config.theme.colors) || COLORS);

	const renderForm = () => (
		<div>
			<div>
				<div>
					<h3>Colores del Portal</h3>
				</div>
				<div>
					<ColorPicker color={colors.primary} name="primary" label="Primario" colorDefault={COLORS.primary} updateColor={setColors} />
					<ColorPicker color={colors.secondary} name="secondary" label="Secundario" colorDefault={COLORS.secondary} updateColor={setColors} />
					<ColorPicker color={colors.light} name="light" label="Primario Claro (efectos)" colorDefault={COLORS.light} updateColor={setColors} />
					<ColorPicker color={colors.dark} name="dark" label="Primario Oscuro (efectos)" colorDefault={COLORS.dark} updateColor={setColors} />
					<ColorPicker color={colors.text} name="text" label="Textos" colorDefault={COLORS.text} updateColor={setColors} />
					<ColorPicker color={colors.background} name="background" label="Background" colorDefault={COLORS.background} updateColor={setColors} />
					<ColorPicker color={colors.success} name="success" label="Éxito" colorDefault={COLORS.success} updateColor={setColors} />
					<ColorPicker color={colors.warning} name="warning" label="Aviso" colorDefault={COLORS.warning} updateColor={setColors} />
					<ColorPicker color={colors.error} name="error" label="Error" colorDefault={COLORS.error} updateColor={setColors} />
					<ColorPicker color={colors.deactivated} name="deactivated" label="Desactivado" colorDefault={COLORS.deactivated} updateColor={setColors} />
				</div>
			</div>
			<br/>
			<button
				style={{
					border: `1px solid ${getSecondary()}`,
					borderRadius: '4px',
					padding: '.5rem',
					color: getSecondary(),
					marginRight: '.5rem',
					backgroundColor: 'transparent'
				}}
				onClick={() => recalculateWithPrimary()}>
				Recalcular colores en base al primario
			</button>
		</div>
	);

	return (
		<FormRootLayout
			form={renderForm()}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={() => {
						updateAndSave({
							theme: {
								colors
							}
						});
					}}
					backgroundColor={{
						backgroundColor: getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			}
		/>
	);
};

export default ConfigColors;

const ColorPicker = ({
	color,
	name,
	label,
	colorDefault,
	updateColor
}) => (
	<div style={{
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	}}>
		<div style={{ flex: '1 0 0', display: 'inline-flex', maxWidth: '50%' }}>
			<TextInput
				type="color"
				name={name}
				value={color || colorDefault}
				onChange={ev => {
					updateColor(oldColor => ({
						...oldColor,
						[name]: ev.target.value
					}));
				}} />
			<TextInput
				floatingText={label}
				name={name}
				value={color || colorDefault}
				onChange={ev => {
					updateColor(oldColor => ({
						...oldColor,
						[name]: ev.target.value
					}));
				}}
			/>
		</div>

		<div style={{ display: 'flex', flexDirection: 'row' }}>
			{color !== colorDefault && <button
				style={{
					border: `1px solid ${getSecondary()}`,
					borderRadius: '4px',
					padding: '.5rem',
					color: getSecondary(),
					marginRight: '.5rem',
					backgroundColor: 'transparent'
				}}
				onClick={() => {
					updateColor(oldColor => ({
						...oldColor,
						[name]: colorDefault
					}));
				}}>
				Color por defecto
			</button>
			}
		</div>
	</div>
);
